import { LabelValue } from "../types/LabelValue";

export type FontType = 'serif' | 'sans' | 'handwriting';

export interface FontFamilyInfo {
    name: string;
    label: string;
    type: FontType;
    source: string;
}

export const FontSizeIntervals = [
    LabelValue('XS', 12),
    LabelValue('S', 22),
    LabelValue('M', 32),
    LabelValue('L', 48),
    LabelValue('XL', 64),
    LabelValue('2XL', 128),
    LabelValue('3XL', 256),
    LabelValue('4XL', 512),
];
